import React from 'react';
import Header from './common/Header';
import { Outlet } from 'react-router-dom';

export const NavWrapper = ({ current_user }) => {
  return (
    <>
      <Header current_user={current_user} />
      <main className='carton' role='main'>
        <Outlet />
      </main>
    </>
  );
};

export const ExportsWrapper = () => {
  return (
    <main className='carton' role='main'>
      <Outlet />
    </main>
  );
};
